// ============================================
// Path: /frontend/src/components/CategoryGridCard.jsx
// Purpose: Category card with icon/image for homepage navigation
// ============================================

import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { ArrowRight } from 'lucide-react';
import { cn } from '../lib/utils';
import ListingImage from './ListingImage'; // ← ADD THIS LINE

export function CategoryGridCard({ href, name, icon, image, isCompact = false, className }) {
  console.log('[CategoryGridCard] Rendering category:', { name, href, isCompact, hasImage: !!image });

  return (
    <Link 
      to={href}
      onClick={() => console.log('[CategoryGridCard] Navigating to:', href)}
    >
      <Card
        className={cn(
          'group relative flex flex-col items-center justify-center overflow-hidden transition-all duration-300 hover:bg-primary hover:text-primary-foreground hover:shadow-lg hover:-translate-y-1',
          isCompact ? 'h-16' : 'h-32',
          className
        )}
      >
        {/* Image fills entire card or Icon */}
        {image ? (
          <>
            <ListingImage 
              src={image} 
              alt={name} 
              className="absolute inset-0 w-full h-full object-cover group-hover:opacity-90 transition-opacity" 
            />
            <h3 className="absolute top-2 right-2 text-sm font-normal z-10 bg-white/95 px-3 py-1 rounded-md shadow-sm">
              {name}
            </h3>
          </>
        ) : icon ? (
          <>
            <div className="text-primary group-hover:text-primary-foreground mb-1">{icon}</div>
            <h3 className={cn('font-normal', isCompact ? 'text-xs' : 'text-sm')}>
              {name}
            </h3>
          </>
        ) : (
          <h3 className={cn('font-normal', isCompact ? 'text-xs' : 'text-sm')}>
            {name}
          </h3>
        )}
        
        <ArrowRight className="absolute bottom-1 right-1 h-3 w-3 opacity-0 transition-opacity group-hover:opacity-100 z-20" />
      </Card>
    </Link>
  );
}